import { type Dispatch, type SetStateAction } from "react";

import { type AvaFeedback, type SupportServiceModel, type ZendeskPlatformModel } from "@doitintl/cmp-models";

import { type AvaConversationRef } from "../Ava/useAvaConversationRefs";

export enum ConversationHistoryPeriod {
  TODAY = "today",
  PREV_7 = "prev7",
  PREV_30 = "prev30",
  OLDER = "older",
}

export type ConversationHistory = Partial<Record<ConversationHistoryPeriod, AvaConversationRef[]>>;

export type TicketAsset = {
  identifier: string;
  asset: string;
  label?: string;
  accountId?: string;
};

export type CaseIQState = {
  content: string;
  platform: string;
  cloudProduct: SupportServiceModel | null;
  asset: string;
  urgency: string;
  technicalDetails: Array<{ name: string; value: string | null }>;
};

export type AvaDialogContextType = {
  caseIQConversationId: string;
  setCaseIQConversationId: (caseIQConversationId?: string) => void;
  platformList: ZendeskPlatformModel[];
  categoryList: SupportServiceModel[];
  isCaseIQOpen: boolean;
  setIsCaseIQOpen: (isCaseIQOpen: boolean) => void;
  accountManagerEmails: string[];
  setAccountManagerEmails: Dispatch<SetStateAction<string[]>>;
  billingProfile: string;
  setBillingProfile: (profile: string) => void;
};

export type MessageAva = {
  content: string;
  role: "ava";
  answerId?: string;
  completed: boolean;
  feedback?: AvaFeedback;
  createdAt: Date;
  isReport: boolean;
  reportBlocked?: boolean;
  additionalData?: string;
};

export type MessageUser = {
  role: "user";
  content: string;
  createdAt: Date;
};

export type Message = MessageAva | MessageUser;

export type FetcherData = {
  clientName: string;
  question: string;
  conversationId: string | undefined;
  flow?: WorkflowsEnum;
};

export enum WorkflowsEnum {
  Default = "default",
  AvaConsole = "ava-console",
  AvaZendesk = "ava-zendesk",
  AnalyticsReports = "analytics-reports",
}

export type CaseIQTechnicalDetails = {
  name: string;
  value: string | null;
};

export type CaseIQFormikValues = {
  platform: string;
  cloudProduct: SupportServiceModel | null;
  asset: TicketAsset | null;
  priority: string;
  content: string;
  requester: string;
  callMe: boolean;
};

export type CaseIQResponse = {
  technicalDetails: Array<{ name: string; value: string | null }>;
  requiredFields: {
    platform: string;
    product: string;
    severity: string;
    assetId: string | null;
  };
};

export type CaseIQPayload = {
  description: string;
  userSelectedFields: {
    subject?: string;
    product?: string;
    platform?: string;
  };
  conversationId?: string;
};
